import Feedback from "components/common/Feedback";
import Typography from "components/common/Typography";
import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { feedbackTypes } from "utils/Types";
import GiveFeedback from "./GiveFeedback";
import "./index.scss";

const ViewFeedback = (props: any) => {
  const viewForm = useAppSelector((state) => state.feedback.formDetails);
  const feedbackLoader = useAppSelector((state) => state?.feedback?.feedbackLoader);

  useEffect(() => {
    return () => {
      props.setFormId(null);
    };
  }, []);

  return (
    <>
      <>
        <Feedback form="updateFeedback" />
        <div className="edit-feedback-container">
          {!feedbackLoader && (
            <div className="feedback-left-container">
              <Typography variant={"h4"} showBold color={tokens.Text.General.PrimaryHeadline}>
                {viewForm?.type}
              </Typography>
              <Typography color={tokens.Text.General.PrimaryBody}>{viewForm?.triggerPoint}</Typography>
            </div>
          )}
          <div className="feedback-right-container">
            <GiveFeedback
              id={props.formId}
              type={feedbackTypes.PlanCompleted}
              showActionButtons={false}
              isOpen={true}
              isCancelButton={true}
              setFormId={props.setFormId}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default ViewFeedback;
